import React, { useState } from 'react';

function Navigation({ activePage, setActivePage }) {
  const [hoveredButton, setHoveredButton] = useState(null);

  const getButtonStyle = (pageKey) => ({
    background: hoveredButton === pageKey ? 'rgba(76, 175, 80, 0.1)' : 'none',
    border: 'none',
    cursor: 'pointer',
    fontWeight: activePage === pageKey ? 'bold' : 'normal',
    color: activePage === pageKey ? '#4CAF50' : '#333',
    fontSize: '16px',
    padding: '8px 12px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    boxShadow: hoveredButton === pageKey ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
  });

  return (
    <nav style={{
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 0',
      backgroundColor: '#f8f9fa',
      marginBottom: '20px',
      borderRadius: '4px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    }}>
      <ul style={{
        display: 'flex',
        listStyle: 'none',
        margin: 0,
        padding: 0
      }}>
        <li style={{ margin: '0 10px' }}>
          <button 
            onClick={() => setActivePage('home')}
            onMouseEnter={() => setHoveredButton('home')}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle('home')}
          >
            Home
          </button>
        </li>
        <li style={{ margin: '0 10px' }}>
          <button 
            onClick={() => setActivePage('mintpixels')}
            onMouseEnter={() => setHoveredButton('mintpixels')}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle('mintpixels')}
          >
            Mint Pixels
          </button>
        </li>
        <li style={{ margin: '0 10px' }}>
          <button 
            onClick={() => setActivePage('about')}
            onMouseEnter={() => setHoveredButton('about')}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle('about')}
          >
            About
          </button>
        </li>
        <li style={{ margin: '0 10px' }}>
          <button 
            onClick={() => setActivePage('faq')}
            onMouseEnter={() => setHoveredButton('faq')}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle('faq')}
          >
            FAQ
          </button>
        </li>
        <li style={{ margin: '0 10px' }}>
          <button 
            onClick={() => setActivePage('pixellist')}
            onMouseEnter={() => setHoveredButton('pixellist')}
            onMouseLeave={() => setHoveredButton(null)}
            style={getButtonStyle('pixellist')}
          >
            Pixel List
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navigation;